import React, { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";
import { requestsAPI } from "../../services/api";
import RequestRow from "./RequestRow";
import { Table, TableHeader, TableBody, TableCell } from "../UI/Table";
import "./RequestsTable.css";

const RequestsTable = ({
  sortedRequests,
  handleSort,
  getSortIndicator,
  onViewDetails,
  onRequestsLoaded,
  isLoad,
}) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const { loading, error, callApi } = useApi();

  useEffect(() => {
    if (!isLoad) loadFundRequests();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoad]);

  const loadFundRequests = async () => {
    try {
      const data = await callApi(requestsAPI.getRequests);
      onRequestsLoaded(data);
    } catch (err) {
      console.error("Failed to load fund requests:", err);
    }
  };

  const handleToggleRow = (requestId) => {
    setExpandedRow(expandedRow === requestId ? null : requestId);
  };

  const tableHeaders = [
    { key: "", label: "", sortable: false },
    { key: "id", label: "Request ID", sortable: true },
    { key: "request_amount", label: "Request Amount", sortable: true },
    { key: "request_type", label: "Request Type", sortable: true },
    { key: "eventId", label: "Event ID", sortable: true },
    { key: "accountName", label: "Account Name", sortable: true },
    { key: "eventDate", label: "Event Date", sortable: true },
    { key: "organizerVerified", label: "Organizer Verified", sortable: true },
    { key: "101", label: "101", sortable: false },
    { key: "", label: "Details", sortable: false },
  ];

  if (loading) {
    return (
      <div className="requests-table__loading">
        <div className="loading-spinner">Loading fund requests...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="requests-table__error">
        <p>Error loading fund requests: {error}</p>
        <button onClick={loadFundRequests} className="retry-btn">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="requests-table">
      <div className="requests-table__header">
        <h2>Fund Requests</h2>
        <div className="requests-table__stats">
          {sortedRequests.length} request
          {sortedRequests.length !== 1 ? "s" : ""} found
        </div>
      </div>

      <Table>
        <TableHeader>
          {tableHeaders.map((header, index) => (
            <TableCell
              key={index}
              header
              onClick={
                header.sortable ? () => handleSort(header.key) : undefined
              }
              style={{
                cursor: header.sortable ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {header.label}
                {header.sortable && getSortIndicator(header.key)}
              </div>
            </TableCell>
          ))}
        </TableHeader>
        <TableBody>
          {sortedRequests.map((request) => (
            <RequestRow
              key={request.id}
              request={request}
              isExpanded={expandedRow === request.id}
              onToggle={handleToggleRow}
              onViewDetails={onViewDetails}
            />
          ))}
        </TableBody>
      </Table>

      {sortedRequests.length === 0 && !loading && (
        <div className="requests-table__empty">No requests found</div>
      )}
    </div>
  );
};

export default RequestsTable;
